import './PrivacyPolicyPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="privacy-policy-page">
      <div className="policy-container">
        <h1 className="policy-title">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
        
        <p className="policy-subtitle">
          (Политика защиты конфиденциальности и обработки персональных данных; Версия 1.0 от 02 января 2026 года)
        </p>

        <p className="policy-intro">
          Настоящая Политика защиты конфиденциальности и обработки персональных данных (далее – «Политика») определяет порядок сбора, хранения, обработки, использования и защиты персональных данных Пользователей сервиса QuickSignAi (далее – «Сервис»), который предоставляется Самозанятой Шариповой Маликой Азимджоновной (далее – «Оператор», «Мы»), действующей в соответствии с законодательством Российской Федерации.
        </p>

        <p className="policy-intro">
          <strong>Используя Сервис, Пользователь выражает полное и безоговорочное согласие с условиями данной Политики.</strong>
        </p>

        <section className="policy-section">
          <h2>1. Правовая основа и цель обработки данных</h2>
          
          <p><strong>1.1.</strong> Обработка персональных данных осуществляется в соответствии с:</p>
          <ul>
            <li>Конституцией Российской Федерации;</li>
            <li>Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
            <li>Гражданским кодексом Российской Федерации;</li>
            <li>Федеральным законом от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации»;</li>
            <li>Иными нормативными правовыми актами Российской Федерации.</li>
          </ul>
          
          <p><strong>1.2.</strong> Целями обработки данных являются:</p>
          <ul>
            <li>обеспечение работы функционала бота QuickSignAi;</li>
            <li>идентификация Пользователя;</li>
            <li>обработка документов (PDF, DOCX, изображений) для размещения электронных печатей и подписей;</li>
            <li>обработка изображений печатей и подписей с использованием технологий искусственного интеллекта для удаления фона;</li>
            <li>хранение истории подписанных документов;</li>
            <li>ведение статистики и аналитики;</li>
            <li>выполнение требований законодательства;</li>
            <li>защита прав и законных интересов Оператора и третьих лиц.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. Состав обрабатываемых данных</h2>
          
          <p><strong>2.1.</strong> В рамках использования Сервиса могут обрабатываться следующие данные:</p>
          <ul>
            <li>Имя и никнейм в Telegram;</li>
            <li>Telegram ID и фото профиля (при наличии);</li>
            <li>Загруженные документы (PDF, DOCX, PNG, JPG);</li>
            <li>Изображения печатей и подписей, загруженные Пользователем;</li>
            <li>История подписанных документов;</li>
            <li>Информация об используемом языке интерфейса и настройках устройства;</li>
            <li>Данные о транзакциях и приобретённых тарифных планах;</li>
          </ul>

          <p><strong>2.2.</strong> Логи взаимодействий:</p>
          <ul>
            <li>Тип выполненного действия (клик, загрузка файла, размещение печати и т.п.);</li>
            <li>Дата и время выполнения действия;</li>
            <li>URL страницы;</li>
            <li>Количество посещений страниц;</li>
            <li>Информация о перемещении по страницам приложения;</li>
            <li>Длительность пользовательской сессии;</li>
            <li>Точки входа (сторонние источники, с которых пользователь переходит в Сервис);</li>
            <li>Точки выхода (ссылки, по которым пользователь переходит на сторонние ресурсы).</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Методы и место обработки</h2>
          
          <p><strong>3.1.</strong> Обработка персональных данных осуществляется автоматизированным и/или неавтоматизированным способами с применением средств вычислительной техники.</p>
          
          <p><strong>3.2.</strong> Данные могут храниться:</p>
          <ul>
            <li>на серверах Telegram (в соответствии с политикой Telegram);</li>
            <li>на защищённых серверах Оператора и/или его партнёров (в том числе за пределами Российской Федерации).</li>
          </ul>
          
          <p><strong>3.3.</strong> При обработке данных применяются меры защиты, включая:</p>
          <ul>
            <li>шифрование данных в процессе передачи и хранения;</li>
            <li>контроль доступа (ограниченный доступ к данным только для уполномоченных лиц);</li>
            <li>регулярное резервное копирование данных;</li>
            <li>применение антивирусного программного обеспечения;</li>
            <li>защиту от несанкционированного доступа к серверам.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Трансграничная передача данных</h2>
          
          <p><strong>4.1.</strong> Пользователь соглашается, что его персональные данные могут передаваться на серверы, расположенные за пределами Российской Федерации, в государства, обеспечивающие адекватную защиту прав субъектов персональных данных.</p>
          
          <p><strong>4.2.</strong> Передача данных осуществляется только для целей, указанных в разделе 1, и с соблюдением требований статей 12 и 20 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
          
          <p><strong>4.3.</strong> Оператор осуществляет трансграничную передачу персональных данных Пользователя для хранения и обработки на серверах хостинг-провайдеров, отвечающих требованиям международных стандартов безопасности ISO/IEC 27001, ISO/IEC 27017, ISO/IEC 27018.</p>
          
          <p><strong>4.4.</strong> Пользователь, продолжая использовать Сервис, даёт согласие на такую передачу.</p>
        </section>

        <section className="policy-section">
          <h2>5. Передача третьим лицам</h2>
          
          <p><strong>5.1.</strong> Оператор вправе передавать персональные данные:</p>
          <ul>
            <li>Партнёрам и подрядчикам для обеспечения работы Сервиса (включая поставщиков хостинга, аналитики, платёжных систем Click и Payme);</li>
            <li>Государственным органам в случаях, прямо предусмотренных законодательством Российской Федерации;</li>
            <li>Для защиты прав и законных интересов Оператора при наличии достаточных оснований полагать, что разглашение таких данных необходимо для идентификации, установления контакта или подачи иска в отношении лица, которое может нарушать права или интересы Оператора.</li>
          </ul>
          
          <p><strong>5.2.</strong> Оператор не продаёт и не передаёт персональные данные Пользователей третьим лицам в маркетинговых целях без получения предварительного явного согласия.</p>
        </section>

        <section className="policy-section">
          <h2>6. Права Пользователя</h2>
          
          <p><strong>6.1.</strong> Пользователь имеет право:</p>
          <ul>
            <li>Получать информацию, касающуюся обработки его персональных данных (статья 14 Федерального закона № 152-ФЗ);</li>
            <li>Требовать уточнения, блокирования или удаления своих персональных данных в случае, если они являются неполными, устаревшими, недостоверными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li>
            <li>Отозвать согласие на обработку персональных данных;</li>
            <li>Требовать устранения неправомерных действий Оператора в отношении его персональных данных;</li>
            <li>Обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор) или в судебном порядке.</li>
          </ul>
          
          <p><strong>6.2.</strong> Для реализации своих прав Пользователь может направить письменный запрос по адресу электронной почты: sharipovamalika.456@gmail.com.</p>
          
          <p><strong>6.3.</strong> Оператор обязуется рассмотреть запрос Пользователя и направить ответ в срок, не превышающий 30 календарных дней с момента получения запроса.</p>
        </section>

        <section className="policy-section">
          <h2>7. Обязанности Пользователя</h2>
          
          <p><strong>7.1.</strong> Пользователь обязуется:</p>
          <ul>
            <li>Предоставлять достоверные персональные данные;</li>
            <li>Не передавать персональные данные третьих лиц без их предварительного согласия;</li>
            <li>Не использовать Сервис в противоправных целях;</li>
            <li>Не загружать документы, содержащие конфиденциальную информацию третьих лиц, государственную тайну или иную информацию, распространение которой ограничено законодательством РФ;</li>
            <li>Обеспечивать сохранность данных своего аккаунта Telegram.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>8. Ответственность</h2>
          
          <p><strong>8.1.</strong> Оператор не несёт ответственности за:</p>
          <ul>
            <li>Сбои в работе платформы Telegram и иных сторонних сервисов;</li>
            <li>Несанкционированный доступ к данным в результате действий третьих лиц, включая хакерские атаки, если Оператором были предприняты все разумные меры по защите данных;</li>
            <li>Действия Пользователя, приведшие к утечке данных (например, передача данных аккаунта третьим лицам);</li>
            <li>Содержание загруженных Пользователем документов, печатей и подписей;</li>
            <li>Юридические последствия использования подписанных через Сервис документов.</li>
          </ul>
          
          <p><strong>8.2.</strong> Пользователь несёт полную ответственность за законность и правомерность использования Сервиса, включая соблюдение авторских прав, прав на изображения печатей и подписей, а также соблюдение требований законодательства РФ.</p>
        </section>

        <section className="policy-section">
          <h2>9. Срок хранения данных</h2>
          
          <p><strong>9.1.</strong> Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, указанных в настоящей Политике, но не менее сроков, установленных законодательством Российской Федерации.</p>
          
          <p><strong>9.2.</strong> После прекращения использования Сервиса данные Пользователя хранятся в течение 90 календарных дней, после чего подлежат удалению, если иное не предусмотрено законодательством РФ.</p>
          
          <p><strong>9.3.</strong> Документы, печати и подписи Пользователя могут быть удалены Оператором по истечении указанного срока или по требованию Пользователя.</p>
        </section>

        <section className="policy-section">
          <h2>10. Безопасность и отказ от ответственности</h2>
          
          <p><strong>10.1.</strong> Все персональные данные обрабатываются с использованием технических и организационных мер безопасности, направленных на защиту данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.</p>
          
          <p><strong>10.2.</strong> Пользователь принимает на себя все риски, связанные с использованием сети Интернет, платформы Telegram и иных информационных технологий, включая риски перехвата данных третьими лицами.</p>
          
          <p><strong>10.3.</strong> Оператор рекомендует Пользователям не передавать данные своего аккаунта Telegram третьим лицам и использовать надёжные пароли для защиты своего профиля.</p>
        </section>

        <section className="policy-section">
          <h2>11. Использование файлов Cookie и аналитики</h2>
          
          <p><strong>11.1.</strong> Сервис может использовать технологии cookie и аналогичные технологии для сбора информации об использовании Сервиса, улучшения пользовательского опыта и проведения статистического анализа.</p>
          
          <p><strong>11.2.</strong> Пользователь может отключить использование файлов cookie в настройках своего браузера, однако это может привести к ограничению функциональности Сервиса.</p>
        </section>

        <section className="policy-section">
          <h2>12. Заключительные положения</h2>
          
          <p><strong>12.1.</strong> Настоящая Политика является неотъемлемой частью Публичной оферты и действует с момента начала использования Сервиса.</p>
          
          <p><strong>12.2.</strong> Оператор вправе вносить изменения в настоящую Политику в одностороннем порядке без предварительного уведомления Пользователей.</p>
          
          <p><strong>12.3.</strong> Новая редакция Политики вступает в силу с момента её размещения в боте QuickSignAi и/или на официальных ресурсах Оператора, если иное не предусмотрено новой редакцией Политики.</p>
          
          <p><strong>12.4.</strong> Продолжение использования Сервиса после внесения изменений в Политику означает согласие Пользователя с такими изменениями.</p>
          
          <p><strong>12.5.</strong> Актуальная версия Политики всегда доступна в Сервисе через меню приложения.</p>
          
          <p><strong>12.6.</strong> Все вопросы, не урегулированные настоящей Политикой, разрешаются в соответствии с законодательством Российской Федерации.</p>
        </section>

        <section className="policy-contacts">
          <h2>Контактная информация Оператора</h2>
          <p><strong>Самозанятая Шарипова Малика Азимджоновна</strong></p>
          <p>ИНН: 501818205010</p>
          <p>E-mail: <a href="mailto:sharipovamalika.456@gmail.com">sharipovamalika.456@gmail.com</a></p>
          <p className="policy-date">Дата размещения: 02 января 2026 года</p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;

